export const environment = {
    production: false,
    //serviceUrl: 'https://eli-beta-services.azurewebsites.net/',
    //betaEnvironmentURL: 'https://eli-beta.ipeccoaching.com/', 
    //productionEnvironmentURL: 'https://eli.ipeccoaching.com/', 
    //ELIAPIURL:'https://ipeceli-staging.azurewebsites.net/api/',
    //ELISSO: 'https://ipec-eli-sso-staging.azurewebsites.net/api/sso/session/revoke'

    //BETA POINTING TO PROD ENVIRONMENT
    serviceUrl: 'https://eli-beta-services.azurewebsites.net/',
    betaEnvironmentURL: 'https://eli-beta.ipeccoaching.com/', 
    productionEnvironmentURL: 'https://eli.ipeccoaching.com/', 
    ELIAPIURL: 'https://ipeceli-staging.azurewebsites.net/api/',
    ELISSO: 'https://ipec-eli-sso-staging.azurewebsites.net/api/sso/session/revoke?code=yTfh062saBj6TBHd5doQAGzL5VMzimX_tnDZkUkjjmUsAzFuy_7H7Q==',
    ELI_SSO_REDIRECTION: 'https://func-eli-sso-redirection-eastus-staging.azurewebsites.net/api',

};

